import { render, staticRenderFns } from "./PatPickup.vue?vue&type=template&id=f84abb24&scoped=true"
import script from "./PatPickup.vue?vue&type=script&lang=js"
export * from "./PatPickup.vue?vue&type=script&lang=js"
import style0 from "./PatPickup.vue?vue&type=style&index=0&id=f84abb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84abb24",
  null
  
)

export default component.exports